import React, { useState } from 'react';
import { useNCZIContext } from '../../Services/NCZIContext';
import { usePatientTreatmentContext } from '../../../Patient/Components/PatientTreatment/ContextProvider';
import useNCZI from '../../Hooks/useNCZI';
import { useLazyUserNcziProfileQuery } from '../../../../graphql/graphql';
import { useEffectAsync } from '../../../../helpers';
import NCZICommandResult from '../NCZICommandResult/NCZICommandResult';

//@ts-ignore
import styles from './NCZIPatient.module.scss';

interface Props {
  children: React.ReactElement | React.ReactElement[];
}

const NCZIPatient: React.FC<Props> = ({ children }) => {
  const {
    patientIdentifier,
    patientBirthNumber,
    setPatientBirthNumber,
  } = useNCZIContext();
  const { patientId } = usePatientTreatmentContext();
  const { fetchPatientIdentifier } = useNCZI();
  const [ getLazyUserData ] = useLazyUserNcziProfileQuery();
  const [ loadingCommandId, setLoadingCommandId] = useState<string | undefined>(
    undefined,
  );

  const handleLoadPatientData = async () => {
    const { user } = await getLazyUserData({
      id: patientId,
    }).unwrap();

    if (user?.profile?.birthNumber) {
      setPatientBirthNumber(user.profile.birthNumber);
    }
  };

  const handleLoadPatientIdentifier = async () => {
    if (patientBirthNumber) {
      const command = await fetchPatientIdentifier(patientBirthNumber);
      if (command.id) {
        setLoadingCommandId(command.id);
      }
    }
  };

  const handleLoadData = async () => {
    // todo for test
    // setPatientInsurance('union');
    // setPatientBirthNumber('8905201426')
    // setPatientIdentifier('00079108528');
    // todo for test

    if(!patientBirthNumber) {
    	await handleLoadPatientData();
    } else if (!patientIdentifier) {
    	await handleLoadPatientIdentifier();
    }
  };

  useEffectAsync(async () => {
    await handleLoadData();
  }, [patientBirthNumber, patientIdentifier]);

  if (!patientIdentifier) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.loadingWrapper}>
          <NCZICommandResult
            commandId={loadingCommandId}
            handleRetryCommand={handleLoadData}
          />
        </div>
      </div>
    );
  }

  return (
    <>
      {children}
    </>
  );
};

export default NCZIPatient;
